import { render, staticRenderFns } from "./LockContestDialog.vue?vue&type=template&id=25128b56"
import script from "./LockContestDialog.vue?vue&type=script&lang=js"
export * from "./LockContestDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports